module.exports = __webpack_public_path__ + "static/media/title.85de7a3f.png";